import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">视频播报</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">视频爆料</h2>
          <p className="mt-2 text-foreground-600 text-sm">深度调查视频报道与独家访谈内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-[11px] text-background-50 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-700 rounded-full mb-2 inline-block">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}